export const FAQ_ITEMS = [
  {
    question: "Qu'est-ce qu'une agence IA d'automatisation comme FastTask ?",
    answer:
      "FastTask est une agence spécialisée dans l'automatisation par intelligence artificielle. Nous concevons et déployons des solutions IA pour les entreprises : gestion des rendez-vous, support client automatisé, qualification des demandes, relances intelligentes et synchronisation avec vos outils métier (CRM, caisse, agenda)."
  },
  {
    question: "Pour quels secteurs FastTask est-il le plus efficace ?",
    answer:
      "Nous intervenons principalement dans trois secteurs : la restauration (réservations, gestion des stocks, fidélisation client), les services médicaux (prise de rendez-vous, réduction des no-shows, gestion administrative) et le commerce retail (gestion des stocks, recommandations personnalisées, service client). Nous adaptons les workflows IA à la réalité opérationnelle de chaque secteur."
  },
  {
    question: "En combien de temps un projet d'automatisation IA peut-il être lancé ?",
    answer:
      "Un premier pilote peut généralement être lancé en 1 à 3 semaines selon la complexité, vos outils existants et le niveau d'intégration souhaité. Notre méthodologie en 4 phases (audit, conception, déploiement, optimisation) garantit une mise en production rapide et maîtrisée."
  },
  {
    question: "Quels résultats concrets peut-on attendre de l'automatisation IA ?",
    answer:
      "Les gains les plus fréquents sont : jusqu'à 40% de temps opérationnel économisé, -35% de coûts opérationnels, réduction de 60% des no-shows en médical, +25% de conversion en retail et une diminution de 35% du gaspillage alimentaire en restauration. Les résultats varient selon votre situation de départ."
  },
  {
    question: "FastTask remplace-t-il les équipes humaines ?",
    answer:
      "Non. L'objectif de l'automatisation IA n'est pas de remplacer les équipes mais de les libérer des tâches répétitives et à faible valeur ajoutée (saisie, rappels, tri des demandes). Vos collaborateurs peuvent ainsi se concentrer sur la relation client, le conseil et le développement de l'activité."
  },
  {
    question: "Comment démarrer avec FastTask ? L'audit est-il vraiment gratuit ?",
    answer:
      "Oui, l'audit initial est entièrement gratuit et sans engagement. Il vous suffit de remplir le formulaire sur notre site. Nous analysons vos processus actuels, identifions les gains rapides et vous proposons une feuille de route claire avec un chiffrage transparent."
  },
  {
    question: "Combien coûte une solution d'automatisation IA avec FastTask ?",
    answer:
      "Le coût dépend de la complexité du projet, du nombre d'intégrations et du volume de traitements. Nous proposons des solutions sur mesure avec un devis détaillé après l'audit gratuit. L'investissement est généralement rentabilisé en moins de 3 mois grâce aux économies réalisées."
  },
  {
    question: "L'automatisation IA est-elle compatible avec mes outils existants ?",
    answer:
      "Oui. Nous intégrons nos solutions avec les principaux outils du marché : logiciels de caisse et de réservation (restaurants), agendas médicaux et systèmes de gestion de cabinet, CRM, ERP et plateformes e-commerce (retail). L'intégration se fait via API ou connecteurs dédiés."
  },
  {
    question: "Mes données sont-elles sécurisées avec FastTask ?",
    answer:
      "Absolument. La sécurité des données est notre priorité. Nous respectons le RGPD et les normes de sécurité en vigueur. Les données sont hébergées en Europe, chiffrées en transit et au repos. Pour le secteur médical, nous respectons les exigences spécifiques de confidentialité des données de santé."
  },
  {
    question: "FastTask intervient-il uniquement à Paris ou partout en France ?",
    answer:
      "FastTask accompagne des clients dans toute la France : Paris, Lyon, Marseille, Toulouse, Bordeaux et au-delà. Nos solutions étant déployées en ligne, nous travaillons à distance avec la même efficacité. Retrouvez le détail sur notre page dédiée « Agence d'automatisation IA en France »."
  },
  {
    question: "FastTask est-elle présente en Tunisie ?",
    answer:
      "Oui. Notre équipe tunisienne est basée à La Marsa, dans le Grand Tunis, et accompagne restaurants, cabinets médicaux et commerces partout en Tunisie — chatbots WhatsApp, agents IA et workflows automatisés, avec des tarifs adaptés au marché local. Retrouvez le détail sur notre page dédiée « Agence d'automatisation IA en Tunisie »."
  }
];
